import { Alert, Button, Grid, TextField, Typography } from "@mui/material";
import { useRef, useState } from "react";
import { UpdateUser } from "../../../../hooks/updateUser";
import { useLoading } from "../../../../components/Loading/useLoading";
import { useSnackbar } from "notistack";

export const DatosGenerales = ({ data }) => {
  const formData = useRef(null);
  const { setAppLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const { updateUserMutation } = UpdateUser();
  const [showAlert, setShowAlert] = useState(false);

  const validateData = () => {
    if (
      formData.current.user_rfc.value === "" ||
      formData.current.user_employeeNumber.value === ""
    ) {
      return false;
    } else {
      return true;
    }
  };

  const handleUpdate = (body) => {
    setAppLoading(true);
    updateUserMutation(
      { id: data?.id, body },
      {
        onSuccess: (data) => {
          enqueueSnackbar("Los datos se actualizaron correctamente", {
            autoHideDuration: 2000,
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          });
        },
        onError: (error) => {
          enqueueSnackbar("Hubo un error al actualizar la información", {
            autoHideDuration: 2000,
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          });
        },
        onSettled: () => {
          setAppLoading(false);
        },
      },
    );
  };

  const handleSave = () => {
    if (validateData()) {
      setShowAlert(false);
      let payload = {
        userRfc: formData.current.user_rfc.value,
        userEmployeeNumber: formData.current.user_employeeNumber.value,
      };
      handleUpdate(payload);
    } else {
      setShowAlert(true);
    }
  };

  return (
    <>
      {data && (
        <Grid
          container
          spacing={0}
          sx={{
            p: 2,
            border: "1px solid #D9D9D9",
            borderRadius: 5,
            height: "100%",
            display: "flex",
            alignContent: "flex-start",
            gap: 2.5,
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              p: 0,
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <span>Nombres</span>
            <Typography
              variant="h6"
              sx={{ fontWeight: 500 }}
              gutterBottom
              component="div"
            >
              {data?.givenName}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              p: 0,
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <span>Apellidos</span>
            <Typography
              variant="h6"
              sx={{ fontWeight: 500 }}
              gutterBottom
              component="div"
            >
              {data?.familyName}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              p: 0,
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <span>Username</span>
            <Typography
              variant="h6"
              sx={{ fontWeight: 500 }}
              gutterBottom
              component="div"
            >
              {data?.username}
            </Typography>
          </Grid>
          <form ref={formData} id="form_dom" style={{ width: "100%" }}>
            <Grid
              item
              xs={12}
              sx={{
                p: 0,
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <span>RFC</span>
              <TextField
                id="user_rfc"
                name="user_rfc"
                size="small"
                defaultValue={data?.rfc}
                fullWidth
                inputProps={{
                  maxLength: 13,
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                p: 0,
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <span>Número de empleado</span>
              <TextField
                id="user_employeeNumber"
                name="user_employeeNumber"
                size="small"
                defaultValue={data?.employeeNumber}
                fullWidth
                inputProps={{
                  maxLength: 50,
                }}
              />
            </Grid>
          </form>
          {showAlert && (
            <Grid
              item
              xs={12}
              sx={{
                p: 0,
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Alert
                severity="warning"
                variant="outlined"
                sx={{
                  width: "100%",
                  mb: 1,
                  p: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Los datos no son correctos, favor de verificar
              </Alert>
            </Grid>
          )}
          <Grid
            item
            xs={12}
            sx={{
              p: 0,
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Button variant="contained" color="primary" onClick={handleSave}>
              Guardar
            </Button>
          </Grid>
        </Grid>
      )}
    </>
  );
};
